import { GET_SEARCH_BAR_DATA } from "../types";

export const setSearchValue = (data) => ({
    type: GET_SEARCH_BAR_DATA,
    payload: data
})